<template>
  <div class="header">
    <!-- <a class="btn_download" @click="onDownload()"></a> -->
    <div
      class="menu"
      :class="{ close: isExpand }"
      @click="isExpand = !isExpand"
    ></div>
    <div
      class="side-bar"
      @touchmove.prevent
      :class="{ show: isExpand, 'other-page': !is_home }"
    >
      <div
        :class="['sidebar', !isFirst ? (isExpand ? 'expand' : 'noexpand') : '']"
      >
        <div class="nav">
          <ul class="nav__ul">
            <li
              v-for="(item, index) in navList"
              :class="['nav__ul__li', currentTab == index ? 'active' : '']"
              :key="item.name"
              @click="clickItem(index, item.link)"
            >
              <img
                v-if="currentTab == index"
                :src="item.bgImageActiveUrlMobile"
                :alt="index"
                class="nav-item-bgImageActiveUrl--mobile"
              />
              <img
                v-else
                :src="item.bgImageUrlMobile"
                :alt="index"
                class="nav-item-bgImageUrl--mobile"
              />
              <img
                v-if="currentTab == index"
                :src="item.bgImageActiveUrl"
                :alt="index"
                class="nav-item-bgImageActiveUrl--pc"
              />
              <img
                v-else
                :src="item.bgImageUrl"
                :alt="index"
                class="nav-item-bgImageUrl--pc"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jumpUrlNewWindow } from '@/js/common.js';
let timer = null;

export default {
  components: {},
  data() {
    return {
      isExpand: false,
      isFirst: true,
      state: this.$store.state,
    };
  },
  watch: {
    is_home(newVal) {
      if (!newVal) {
        this.currentTab = 0;
      }
    },
  },
  computed: {
    navList() {
      return this.state.navList;
    },
    currentTab: {
      get() {
        return this.state.currentTab;
      },
      set(val) {
        this.state.currentTab = val;
      },
    },
    cur_route() {
      return this.state.currentRoute;
    },
    // 是否在首页
    is_home() {
      return this.cur_route == 'Home';
    },
  },
  methods: {
    clickItem(index, link) {
      clearTimeout(timer);
      window._isJumpingByclick_ = true;
      this.isExpand = !this.isExpand;
      this.currentTab = index;
      this.goCombtn(link);
      this.isExpand = false;
      timer = setTimeout(() => {
        window._isJumpingByclick_ = false;
      }, 2000);
    },
    goCombtn(link) {
      if (link === 'order') {
        jumpUrlNewWindow('https://www.phuhocongluoc.vn/#/login');
      } else {
        let ViewDomElement = document.querySelector(link);
        ViewDomElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    expandBar() {
      this.isExpand = !this.isExpand;
      this.isFirst = false;
    },
    // onDownload() {
    //   var u = navigator.userAgent;
    //   var ua = u.toLowerCase();
    //   // window.open("https://happyboss.onelink.me/vJom/7a475399");
    //   if (/iphone|ipad|ipod/.test(ua)) {
    //     window.open('https://itunes.apple.com/tw/app/id1572988056');
    //     //ios
    //   } else if (/android/.test(ua)) {
    //     window.open(
    //       'https://play.google.com/store/apps/details?id=com.lets.psan.hwft',
    //     );
    //     //android
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
@keyframes expand {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes noexpand {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

@media screen and (max-width: 768px) {
  .header {
    width: 100%;
    height: 102px;
    background: url('https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_top_bar.png') no-repeat;
    background-size: 100%;
    background-size: cover;
    display: flex;
    align-items: center;
    position: fixed;
    padding-right: 40px;
    top: 0;
    left: 0;
    z-index: 100;

    .btn_download {
      width: 167px;
      height: 47px;
      display: block;
      margin-left: 404px;
      background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/btn_download.png) no-repeat no-repeat;
      background-size: 100% 100%;
    }

    .menu {
      width: 38px;
      height: 25px;
      background: url('https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/header_menu.png') no-repeat;
      background-size: contain;
      margin-left: auto;

      &.close {
        width: 30px;
        height: 29px;
        background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/header_menu_close.png);
      }
    }
  }

  .side-bar {
    position: fixed;
    right: 0;
    top: 102px;
    height: 100%;
    width: 100%;
    z-index: 20;
    display: none;
    background-color: rgba($color: #000000, $alpha: 0.8);

    &.show {
      display: block;
    }

    .sidebar {
      position: absolute;
      right: 0;
      top: 0;
      width: 170px;
      height: 265px;
      z-index: 1000;
      background-image: url('https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/mobile_sidebar.png');
      background-repeat: no-repeat;
      background-size: 100%;

      &.noexpand {
        //收起
        // animation: noexpand .5s ease-in 1;
        // animation-fill-mode: forwards;
        display: none;
      }

      &.expand {
        //展开
        // animation: expand .5s ease-in 1;
        // animation-fill-mode: forwards;
        display: flex;
      }

      .nav {
        width: 100%;
        height: 100%;

        .nav__ul {
          height: 100%;
          display: flex;
          flex-direction: column;
          > .nav__ul__li {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            cursor: pointer;
            .nav-item--mobile {
              display: none;
            }
            .nav-item-bgImageActiveUrl--mobile {
              width: 100%;
              height: 100%;
            }
            .nav-item-bgImageUrl--mobile {
              height: 27px;
              width: auto;
            }
            .nav-item-bgImageActiveUrl--pc {
              display: none;
            }
            .nav-item-bgImageUrl--pc {
              display: none;
            }
          }
        }
      }

      .login {
        font-family: GenJyuuGothic-P-Medium;
        font-size: 32px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 65px;
        letter-spacing: -1px;
        color: #b1784e;
        display: flex;
        justify-content: center;
        width: 100%;
        align-items: center;
        cursor: pointer;

        > img {
          width: 20px;
          margin-right: 10px;
        }
      }

      .expand-btn {
        display: none;
      }
    }
  }
}

@media screen and (min-width: 769px) {
  .side-bar {
    display: block;

    &.other-page {
      display: none;
    }

    .sidebar {
      position: fixed;
      width: 100%;
      height: 60px;
      z-index: 1000;
      background-image: url('https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/bg--header--pc.png');
      background-size: 100%;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;

      .nav {
        height: 100%;
        padding-left: 611px;

        .nav__ul {
          height: 100%;
          display: flex;
          > .nav__ul__li {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 160px;
            height: 100%;
            cursor: pointer;
            .nav-item--mobile {
              display: none;
            }
            .nav-item-bgImageActiveUrl--pc {
              width: 100%;
              height: 100%;
            }
            .nav-item-bgImageUrl--pc {
              width: 68px;
              height: 18px;
            }
            .nav-item-bgImageActiveUrl--mobile {
              display: none;
            }
            .nav-item-bgImageUrl--mobile {
              display: none;
            }
          }
        }
      }

      .expand-btn {
        position: absolute;
        left: 100%;
        top: calc(50% - 83px);
        cursor: pointer;

        img {
          width: 90px;
          height: 160px;
        }
      }
    }
  }
}
</style>